"use strict";

import * as filterStore from './filter-store';

function renderItem(filter) {
    let text;

    if (filter.isCheckboxFilter) {
        text = filter.label;
    } else if(filter.quickFilterText) {
        text = filter.quickFilterText;
    } else {
        text = filter.label ? filter.label + ': ' + filter.value : filter.value;
    }

    return '<button class="quick-filter"><span class="icon icon-x quick-filter__icon" aria-label="Remove"></span>' + text + '</button>';
}

function render($quickFilterBar, state) {
    $quickFilterBar.empty();

    let filters = $.grep(state, function (filter) {
        return filter.isFilter && !filter.isHidden;
    });

    $.each(filters, function (index, filter) {
        let $newItem;
        if (filter.isCheckboxFilter) {
            if (filter.isActive) {
                $newItem = $(renderItem(filter));
                $quickFilterBar.append($newItem);
            }
        } else {
            if (filter.value) {
                $newItem = $(renderItem(filter));

                console.log($newItem);
                $quickFilterBar.append($newItem);
            }
        }

        if ($newItem) {
            $newItem.on('click', function () {
                filterStore.removeFilter(filter);
            });
        }
    });

    /* show remove btn and reset form */
    if($('.quick-filter').length){
        $('.js-filter-form-quick-filter').append('<button class="quick-filter js-quick-filter-all"><span class="icon icon-x quick-filter__icon" aria-label="Remove all"></span>Remove all</button>');

        $('.js-quick-filter-all').on('click', function () {
            let url = window.location.toString();
            if (url.indexOf("?") > 0) {
                let clean_url = url.substring(0, url.indexOf("?"));
                window.location.href = clean_url;
            }
        });
    }


}

export function initInScope($scope) {
    $scope.find('.js-filter-form-quick-filter').each(function (index, quickFilterBar) {
        let $quickFilterBar = $(quickFilterBar);
        render($quickFilterBar, filterStore.getState());

        filterStore.subscribe(function () {
            render($quickFilterBar, filterStore.getState());
        });
    });
}
    
